export const cognitoIdentityIdPrefix = "aws.cognito.identity-id.";
